<template>
  <div>
    <div class="document-container">
      <div class="document">
        <div class="header">
          <es-header>
            <template #header>
              <div class="header-title">
                Add Options
              </div>
            </template>
          </es-header>
        </div>
        <div class="tabs" style="padding-left:1rem">
          <ul>
            <li class="is-active">
              <a tabindex="0" role="button">
                USER
              </a>
            </li>
          </ul>
        </div>
        <div class="content section-indent">
          <es-form>
            <template #es-form>
              <div class="row removeUnderline">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label" for="addOptionControl">
                      Add Option
                    </label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <input type="text" id="addOptionControl"
                          class="input is-static is-readonly"
                          readonly
                          value="Individual User">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </es-form>
          <es-form>
            <template #es-form-header>
              <div class="header-container">
                <div class="header-elements">
                  <font-awesome-icon :icon="['fas', 'user']" size="lg"/>
                </div>
                <div class="header-elements">
                  <h6 class="title">
                    Person Information
                  </h6>
                </div>
              </div>
            </template>
            <template #es-form>
              <div class="row removeUnderline">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label" for="firstNameControl">
                      First Name
                    </label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <input class="input" id="firstNameControl"
                          :class="{ 'is-danger' : hasErrorFirstName}"
                          type="text"
                          v-model="firstName"
                          @keyup.prevent="checkField('firstName')"
                        >
                      </div>
                      <span v-if="hasErrorFirstName" class="help is-danger">
                        {{ msgFirstName }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row removeUnderline">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label" for="lastNameControl">
                      Last Name
                    </label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <input class="input" id="lastNameControl"
                          :class="{ 'is-danger' : hasErrorLastName }"
                          type="text"
                          v-model="lastName"
                          @keyup.prevent="checkField('lastName')"
                        >
                      </div>
                      <span v-if="hasErrorLastName" class="help is-danger">
                        {{ msgLastName }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </es-form>
          <es-form>
            <template #es-form-header>
              <div class="header-container">
                <div class="header-elements">
                  <font-awesome-icon :icon="['fas', 'user-lock']" size="lg"/>
                </div>
                <div class="header-elements">
                  <h6 class="title">
                    Login Information
                  </h6>
                </div>
              </div>
            </template>
            <template #es-form>
              <div class="row removeUnderline">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label for="formLoginEmail" class="label">
                      Email Address (User Name)
                    </label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <input
                        placeholder="sample@email.com"
                        id="formLoginEmail"
                        class="input"
                        type="email"
                        v-model="email"
                        @keyup.prevent="checkField('email')"
                      />
                      <p v-if="hasErrorEmail"
                        class="invalid-feedback has-text-left"
                      >
                        {{ msgEmail }}
                      </p>
                      <div class="form-subtext has-text-left">
                        Email address is used as username.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </es-form>
          <es-form>
            <template #es-form-header>
              <div class="header-container">
                <div class="header-elements">
                  <font-awesome-icon :icon="['fas', 'check-circle']" size="lg" />
                </div>
                <div class="header-elements">
                  <h6 class="title">
                    Authorization Information
                  </h6>
                </div>
              </div>
            </template>
            <template #es-form>
              <div class="row removeUnderline">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label" for="personTypeControl">
                      Person Type(s)
                    </label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <es-select
                          v-bind:multi="true"
                          v-on:update:values="personTypes = $event; checkField('personType')"
                          valueTpl="${name}"
                          :preSelected=null
                          :setValues="userPersonTypes"
                          keyValue="code"
                          v-bind:clearOut="true"
                          controlId="personTypeControl"
                        />
                      </div>
                      <p v-if="hasErrorPersonType"
                        class="invalid-feedback has-text-left"
                      >
                        {{ msgPersonType}}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label" for="roleControl">
                      Primary Role
                    </label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <div class="select is-full-width"
                          :class="{ 'is-danger' : hasErrorRole}"
                        >
                          <select class="input is-full-width"
                            id="roleControl"
                            v-model="role"
                            @change="getPermissions(role);checkField('role')"
                            :disabled="!personTypes"
                          >
                            <option value=""></option>
                            <option v-for="(role, index) in sortedRoles"
                              :key="index" :value="role.id"
                            >
                              {{ role.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <p v-if="hasErrorRole"
                        class="invalid-feedback has-text-left"
                      >
                        {{ msgRole}}
                      </p>
                      <div class="form-subtext has-text-left">
                        Role manages what components and privileges a user can have
                        access to within the application.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="role">
                <div class ="row removeUnderline">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">
                        District
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <div class="buttons has-addons">
                            <button v-for="(option, index) in districtOptions"
                              :key="index"
                              :disabled = "option.name === 'All Districts' ? !isStateUser : false"
                              class="button no-radius"
                              :class="{'selected-type': districtType === option.name}"
                              @click="selectedType('districtType', option.name)"
                            >
                              {{ option.label }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row removeUnderline"
                  v-if="districtType === 'Specific Districts'"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label" for="districtControl">
                        District(s)
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <es-select
                            :class="{'is-danger': hasErrorDistrict }"
                            v-bind:multi="true"
                            v-bind:search="true"
                            api="districts"
                            v-on:update:values="districts = $event"
                            ref="selDistricts"
                            :valueTplFn="(result) => `${result.location.name} (${result.code})`"
                            searchMinLength="2"
                            keyValue="code"
                            controlId="districtControl"
                          />
                        </div>
                        <span v-if="hasErrorDistrict" class="help is-danger">
                          {{ msgDistrict }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row removeUnderline">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">
                        School
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <input class="input is-static"
                            type="text"
                            v-model="schoolType"
                            readonly
                            v-if=" districtType === 'All Districts'"
                            aria-label="School"
                          />
                          <div class="buttons has-addons"
                            v-if="districtType === 'Specific Districts'"
                          >
                            <button v-for="(option, index) in schoolOptions"
                              :key="index"
                              :disabled="(!districts.length) ||
                                (districts.length &&
                                (option.name === 'All Schools' ? userSchools.length !== 0 : false))"
                              class="button no-radius"
                              :class="{'selected-type': schoolType === option.name}"
                              @click="selectedType('schoolType', option.name)"
                            >
                              {{ option.label }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row removeUnderline"
                  v-if="schoolType === 'Specific Schools'"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label" for="schoolControl">
                        School(s)
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <es-select
                            :class="{ 'is-danger': hasErrorSchool }"
                            v-bind:multi="true"
                            v-bind:search="true"
                            api="schools"
                            v-on:update:values="schools = $event"
                            ref="selSchools"
                            :apiQueryParams="getDistrictParams"
                            :valueTplFn="(result) => `${result.location.name} (${result.code})`"
                            :subValueTplFn="(result) => `${result.districtLocation.name}
                              (<i>${result.districtCode }</i>)`"
                            searchMinLength="2"
                            keyValue="code"
                            controlId="schoolControl"
                          />
                        </div>
                        <span v-if="hasErrorSchool" class="help is-danger">
                          {{ msgSchool }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="showMatchTypes">
                  <div class="row removeUnderline">
                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label" for="matchTypeControl">
                          DirectMatch Match Type(s)
                        </label>
                      </div>
                      <div class="field-body">
                        <div class="field">
                          <div class="control">
                            <es-select
                             v-bind:multi="true"
                             v-on:update:values="programs = $event;"
                             key-value="code"
                            :setValues="filterProgramsByPersonType"
                            :value-tpl-fn="(result) => `${result.description}`"
                            controlId="matchTypeControl"
                            />
                          </div>
                          <div class="form-subtext has-text-left">
                            Match Type allows the user to access to specific match types
                            throughout the application.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row removeUnderline">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">
                        Location Group
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <div class="buttons has-addons">
                            <button v-for="(option, index) in locationGroupOptions"
                              :disabled="(option.label === 'All Groups' && !hasAllGroupAccess) ||
                                (option.label === 'Specific Groups'
                                  && !(hasSpecificGroupAccess || hasAllGroupAccess))"
                              :key="index"
                              class="button no-radius"
                              :class="{'selected-type': locationGroupType === option.label}"
                              @click="selectedType('locationGroupType', option.label)"
                            >
                              {{ option.label }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row removeUnderline"
                  v-if="locationGroupType === 'Specific Groups'"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label" for="locationGroupControl">
                        Location Group(s)
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <es-select
                            :class="{ 'is-danger': hasErrorLocationGroup }"
                            v-bind:multi="true"
                            v-bind:search="true"
                            api="location-groups"
                            :apiQueryParams="locationGroupQueryParams"
                            v-on:update:values="locationGroups = $event"
                            ref="selGroups"
                            valueTpl="${label}"
                            searchMinLength="3"
                            keyValue="id"
                            controlId="locationGroupControl"
                          />
                        </div>
                        <div class="form-subtext has-text-left">
                          Location Group manages what records a user can view/edit within locations.
                        </div>
                        <span v-if="hasErrorLocationGroup" class="help is-danger">
                          {{ msgLocationGroup }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </es-form>
          <es-form>
            <template #es-form>
              <div class="form-subtext has-text-left" style="padding-left: 2.3rem">
                If this user needs additional role assignments,
                please add the roles from the User Profile after adding the user.
              </div>
            </template>
          </es-form>
          <div class="buttons has-addons is-right">
            <span class="button" style="border: none">
              <router-link
                :to="`/${activeModule.name}/securityManager`"
                class="btn btn-link"
              >
                Cancel
              </router-link>
            </span>
            <span class="button" style="border: none">
              <button
                class="button is-primary"
                @click.stop.prevent="formValidation"
              >
                Add User
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUserLock,
  faCheckCircle,
  faIdCard,
  faUser,
} from '@fortawesome/pro-solid-svg-icons';
import EsHeader from '@/components/EsHeader.vue';
import EsForm from '@/components/EsForm.vue';
import EsSelect from '@/components/EsSelect.vue';
import RolePermissions from '@/mixins/RolePermissions';
import EmailUtils from '@/mixins/EmailUtils';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import FieldLabels from '@/mixins/FieldLabels';
import NotificationManager from '@/mixins/NotificationManager';

library.add(
  faUserLock,
  faCheckCircle,
  faIdCard,
  faUser,
);

export default {
  mixins: [
    BreadcrumbsManager,
    EmailUtils,
    NotificationManager,
    FieldLabels,
    RolePermissions,
  ],
  components: {
    EsForm,
    EsHeader,
    EsSelect,
  },
  props: [
    'headerTitle',
  ],
  data() {
    return {
      firstName: null,
      lastName: null,
      email: null,
      loading: false,
      role: null,
      apiQueryParams: { active: 'true' },
      locationGroupQueryParams: { status: 'true' },
      roles: [],
      districts: [],
      schools: [],
      locationGroups: [],
      programs: [],
      districtOptions: [],
      districtType: null,
      schoolOptions: [],
      schoolType: 'All Schools',
      locationGroupOptions: [],
      locationGroupType: 'No Groups',
      hasErrorFirstName: false,
      hasErrorLastName: false,
      hasErrorEmail: false,
      hasErrorLocationGroup: false,
      hasErrorRole: false,
      hasErrorDistrict: false,
      hasErrorSchool: false,
      hasErrorAPI: false,
      msgWarning: false,
      apiMsg: null,
      msgFirstName: null,
      msgLastName: null,
      msgEmail: null,
      msgDistrict: null,
      msgPersonType: null,
      msgRole: null,
      msgSchool: null,
      msgLocationGroup: null,
      messages: [],
      formErrorMsg: 'There were some errors. Please fix the errors highlighted in the fields below.',
      personTypes: null,
      hasErrorPersonType: false,
    };
  },
  watch: {
    districtType() {
      if (this.districtType === 'All Districts') {
        this.schoolType = 'All Schools';
      }
    },
    districts() {
      if (this.districts.length && this.hasErrorDistrict) {
        this.hasErrorDistrict = false;
        this.hideErrorNotification();
      }
    },
    schools() {
      if (this.schools.length && this.hasErrorSchool) {
        this.hasErrorSchool = false;
        this.hideErrorNotification();
      }
    },
    locationGroups() {
      if (this.locationGroups.length && this.hasErrorLocationGroup) {
        this.hasErrorLocationGroup = false;
        this.hideErrorNotification();
      }
    },
  },
  created() {
    let targetName;
    if (this.activeModule.name === 'locationID') {
      targetName = 'LISecurityManager';
    } else if (this.activeModule.name === 'directMatch') {
      targetName = 'DMSecurityManager';
    } else {
      targetName = 'PidSecurityManager';
    }

    this.setBreadcrumb([
      {
        text: 'Security Manager',
        to: { name: targetName },
      },
      { text: 'Add Options', to: {} },
    ]);
    this.districtOptions = [
      {
        name: 'All Districts',
        label: 'All Districts',
      },
      {
        name: 'Specific Districts',
        label: 'Specific Districts',
      },
    ];
    this.schoolOptions = [
      {
        name: 'All Schools',
        label: 'All Schools',
      },
      {
        name: 'Specific Schools',
        label: 'Specific Schools',
      },
    ];
    this.locationGroupOptions = [
      {
        label: 'All Groups',
      },
      {
        label: 'Specific Groups',
      },
      {
        label: 'No Groups',
      },
    ];
    if (this.isStateUser) {
      this.districtType = 'All Districts';
    } else {
      this.districtType = 'Specific Districts';
    }
    if (!this.userSchools.length) {
      this.schoolType = 'All Schools';
    } else {
      this.schoolType = 'Specific Schools';
    }
    if (this.locationGroupType === 'No Groups') {
      this.locationGroups = [{ id: -1 }];
    }
    this.onLoad();
  },
  computed: {
    ...mapGetters(['userPersonTypes']),
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
      userSchools: 'userSchools',
      hasAllGroupAccess: 'hasAllGroupAccess',
      hasSpecificGroupAccess: 'hasSpecificGroupAccess',
      isStateUser: 'isStateUser',
    }),
    ...mapGetters('lookups', [
      'activePrograms',
    ]),
    getDistrictParams() {
      const params = {};
      params.districtCode = this.districts.map(district => district.code);
      return params;
    },
    sortedRoles() {
      return this.roles.slice().sort((a, b) => (a.name > b.name ? 1 : -1));
    },
    hasError() {
      return this.hasErrorDistrict
      || this.hasErrorSchool
      || this.hasErrorLocationGroup
      || this.hasErrorRole
      || this.hasErrorPersonType
      || this.hasErrorFirstName
      || this.hasErrorLastName
      || this.hasErrorEmail;
    },
    filterProgramsByPersonType() {
      const selectedPersonType = [...this.personTypes.map(type => type.code), '00'];
      return this.activePrograms.filter(program => selectedPersonType
        .includes(program.personTypeCode));
    },
  },
  methods: {
    ...mapActions([
      'addUser',
      'getRoles',
    ]),
    ...mapActions('lookups', [
      'loadPersonTypes',
      'loadPrograms',
    ]),
    async onLoad() {
      try {
        this.toggleLoading();
        const res = await Promise.all([
          this.getRoles(),
          this.loadPersonTypes(),
          this.loadPrograms(),
        ]);
        this.roles = res[0].data;
      } catch (error) {
        this.apiMsg = `${error.response.status === 500 ? 'Network Error' : error.response.data.message}`;
        this.showNotification('danger', [this.apiMsg]);
      }
      this.toggleLoading();
    },
    hideErrorNotification() {
      if (!this.hasError) {
        this.hideNotification();
      }
    },
    getPermissions(role) {
      if (role) {
        this.hasRolePermissions(role);
      } else {
        this.privileges.clear();
      }
    },
    toggleLoading() {
      this.loading = !this.loading;
    },
    selectedType(field, option) {
      if (field === 'districtType') {
        if (option === 'All Districts') {
          if (this.schools.length && !this.hasError) {
            this.showNotification('warning',
              ['Data has been removed from the School(s) field based on the changes to the District(s) field.']);
            this.msgWarning = true;
          }
          this.$refs.selDistricts.clear();
          if (this.schoolType === 'Specific Schools') {
            this.$refs.selSchools.clear();
          }
          this.hasErrorDistrict = false;
          this.msgDistrict = null;
        }
        this.districtType = option;
      }
      if (field === 'schoolType') {
        if (option === 'All Schools') {
          this.$refs.selSchools.clear();
          this.hasErrorSchool = false;
          this.msgSchool = null;
        }
        this.schoolType = option;
      }
      if (field === 'locationGroupType') {
        if (option === 'All Groups') {
          if (this.$refs.selGroups) {
            this.$refs.selGroups.clear();
          } else {
            this.locationGroups = [];
          }
          this.hasErrorLocationGroup = false;
          this.msgGroup = null;
        } else if (option === 'No Groups') {
          this.locationGroups = [{ id: -1 }];
          this.hasErrorLocationGroup = false;
          this.msgLocationGroup = null;
        } else if (option === 'Specific Groups') {
          this.locationGroups = this.locationGroups.filter(lg => lg.id !== -1);
        }
        this.locationGroupType = option;
      }
      if (!this.msgWarning && !this.hasError) {
        this.hideNotification();
      }
      this.msgWarning = false;
    },
    checkField(field) {
      if (field === 'firstName') {
        this.validateField(this.firstName, 60, 'First Name', 'hasErrorFirstName', 'msgFirstName');
      } else if (field === 'lastName') {
        this.validateField(this.lastName, 60, 'Last Name', 'hasErrorLastName', 'msgLastName');
      } else if (field === 'email') {
        this.validateRequiredField(this.email, 'Email address', 'hasErrorEmail', 'msgEmail');
      } else if (field === 'role') {
        this.validateRequiredField(this.role, 'Role', 'hasErrorRole', 'msgRole');
      } else if (field === 'districts') {
        if (this.districtType === 'Specific Districts') {
          this.validateArrayField(this.districts, 'District', 'hasErrorDistrict', 'msgDistrict');
        }
      } else if (field === 'schools') {
        if (this.schoolType === 'Specific Schools') {
          this.validateArrayField(this.schools, 'School', 'hasErrorSchool', 'msgSchool');
          if (this.schools.length > 0) {
            const isSchoolSelected = this.districts.every(district => this.schools
              .some(school => school.districtCode === district.code));
            if (!isSchoolSelected) {
              this.hasErrorSchool = true;
              this.msgSchool = 'Please select at least one school for each selected district(s)';
            }
          }
        }
      } else if (field === 'groups') {
        if (this.locationGroupType === 'Specific Groups') {
          this.validateArrayField(this.locationGroups, 'Location Group', 'hasErrorLocationGroup', 'msgLocationGroup');
        }
      } else if (field === 'personType') {
        this.validateRequiredField(this.personTypes, 'Person Type', 'hasErrorPersonType', 'msgPersonType');
      }
    },
    checkFormat(field) {
      if (field === 'email') {
        if ((this.email !== '' || this.email !== null) && !this.isWelformed(this.email.trim())) {
          this.msgEmail = 'Email address is invalid.';
          this.hasErrorEmail = true;
        }
      }
    },
    async formValidation() {
      this.resetErrors();
      this.messages = [];
      this.checkField('firstName');
      this.checkField('lastName');
      this.checkField('email');
      this.checkFormat('email');
      this.checkField('role');
      this.checkField('personType');
      this.checkField('districts');
      this.checkField('schools');
      this.checkField('groups');
      const errors = this.hasErrorFirstName
      || this.hasErrorLastName
      || this.hasErrorEmail
      || this.hasErrorRole
      || this.hasErrorDistrict
      || this.hasErrorSchool
      || this.hasErrorLocationGroup;
      if (errors === true) {
        this.messages.push(this.formErrorMsg);
        this.showNotification('danger', this.messages);
      } else {
        const user = {};
        user.firstName = this.firstName.trim();
        user.lastName = this.lastName.trim();
        user.email = this.email.trim();

        let districtsList = this.districts.map(val => ({ code: val.code }));
        if (districtsList.length === 0) {
          districtsList = [{ code: 'ALL_LOCATIONS' }];
        }
        let schoolsList = this.schools.map(val => ({ code: val.code, districtCode: val.districtCode }));
        if (schoolsList.length === 0) {
          schoolsList = districtsList.map(val => ({ code: 'ALL_LOCATIONS', districtCode: val.code }));
        }

        user.locationPermissions = [{
          roleId: this.role,
          locationGroups: this.locationGroups.map(val => ({ locationGroupId: val.id })),
          districts: districtsList,
          schools: schoolsList,
          programs: this.programs.map(val => ({ programCode: val.code })),

        }];
        user.userPersonTypes = this.personTypes
          .map(val => ({ userId: null, personTypeCode: val.code }));

        try {
          await this.addUser(user);
          this.$router.push(
            {
              path: `/${this.activeModule.name}/securityManager`,
              params: { message: ['The user has been added successfully', 'Account Sign-up email has been sent to the user'] },
            },
          );
        } catch (error) {
          const { status } = error.response;
          if (status === 400) {
            this.apiMsg = `${error.response.data.message}`;
          } else if (status === 403) {
            this.apiMsg = 'User Does Not Have Access To This Resource.';
          } else {
            this.apiMsg = 'Something went wrong.';
          }
          this.messages.push(this.apiMsg);
          this.showNotification('danger', this.messages);
        }
      }
    },
    resetErrors() {
      this.messages = [];
      this.hasErrorFirstName = false;
      this.hasErrorLastName = false;
      this.hasErrorEmail = false;
      this.hasErrorRole = false;
      this.hasErrorDistrict = false;
      this.hasErrorSchool = false;
      this.hasErrorLocationGroup = false;
      this.msgFirstName = null;
      this.msgLastName = null;
      this.msgEmail = null;
      this.msgRole = null;
      this.msgDistrict = null;
      this.msgSchool = null;
      this.msgLocationGroup = null;
      this.apiMsg = null;
    },
    validateField(value, maxLength, fieldName, errorFlag, errorMsgField) {
      if (!value) {
        this[errorFlag] = true;
        this[errorMsgField] = `${fieldName} is required`;
      } else if (value.length > maxLength) {
        this[errorFlag] = true;
        this[errorMsgField] = `${fieldName} allows a maximum of ${maxLength} characters.`;
      } else {
        this[errorFlag] = false;
        this[errorMsgField] = null;
      }
    },
    validateRequiredField(value, fieldName, errorFlag, errorMsgField) {
      if (!value) {
        this[errorFlag] = true;
        this[errorMsgField] = `${fieldName} is required`;
      } else {
        this[errorFlag] = false;
        this[errorMsgField] = null;
      }
    },
    validateArrayField(array, fieldName, errorFlag, errorMsgField) {
      if (!array || array.length === 0) {
        this[errorFlag] = true;
        this[errorMsgField] = `${fieldName} is required`;
      } else {
        this[errorFlag] = false;
        this[errorMsgField] = null;
      }
    },
  },
};
</script>

<style lang="sass" scoped>

  .es-actions
    margin: 0 1rem
    padding: 0 25%
  .input
    width: 400
  .form-subtext
    color: #757575
    font-style: italic
    font-size: .85rem
  .section-indent
    padding-top: 2rem
    padding-bottom: 2rem
    width: 90%
    margin: auto
  .buttons
    margin-top: 10px
  .is-readonly
    background: #eee
  .invalid-feedback
    font-style: italic
    color: #dc3545
    font-size: .8rem
    padding: .25rem 0 .25rem .15rem
  .selected-type
    background-color: #ccc
    font-weight: bold
  .removeUnderline
    border-bottom: 1px solid transparent !important
</style>
